import React, { useEffect, useState } from "react";
import PoolPanel from "./PoolPanel";
import PoolItemLoader from "./PoolItemLoader";
import PoolTabsLoader from "./PoolTabsLoader";
import { useApi } from "../lib/useApi";

const noPools = { PoolVolumes: [], S6Pools: [], S10Pools: [], S13Pools: [], S4Pools: [], S13XPools: [], S11Pools: [], S1Pools: [], SSPools: [], SCPools: [] };

const PoolsWidget = () => {
  const [PanelSelected] = useState(1);

  const groupSummaryPools = (json) => {
    const summary_pools = json.value;
    const temps6 = [];
    const temps10 = [];
    const temps13 = [];
    const temps4 = [];
    const temps13X = [];
    // const tempsM = [];
    // const temps8 = [];
    const temps11 = [];
    const temps1 = [];
    const tempsS = [];
    const tempsC = [];
    const pools = {};
    for (const summary_pool of summary_pools) {
      if (summary_pool.PartitionKey.startsWith("S6 ")) {
        temps6.push(summary_pool);
      } else if (summary_pool.PartitionKey.startsWith("S10 ")) {
        temps10.push(summary_pool);
      } else if (summary_pool.PartitionKey.startsWith("S13 ")) {
        temps13.push(summary_pool);
      } else if (summary_pool.PartitionKey.startsWith("S4 ")) {
        temps4.push(summary_pool);
      } else if (summary_pool.PartitionKey.startsWith("S13X ")) {
        temps13X.push(summary_pool);
        // } else if (summary_pool.PartitionKey.startsWith("Megastrike")) {
        //   tempsM.push(summary_pool);
        // } else if (summary_pool.PartitionKey.startsWith("S8 ")) {
        //   temps8.push(summary_pool);
      } else if (summary_pool.PartitionKey.startsWith("S11 ")) {
        temps11.push(summary_pool);
      } else if (summary_pool.PartitionKey.startsWith("S1 ")) {
        temps1.push(summary_pool);
      } else if (summary_pool.PartitionKey.startsWith("SS ")) {
        tempsS.push(summary_pool);
      } else if (summary_pool.PartitionKey.startsWith("SC ")) {
        tempsC.push(summary_pool);
      }
    }
    temps6.sort((a, b) => {
      if (a.RowKey < b.RowKey) return -1;
      if (a.RowKey > b.RowKey) return 1;
      return a.programCode.localeCompare(b.programCode);
    });
    pools.S6Pools = temps6;
    temps10.sort((a, b) => {
      if (a.RowKey < b.RowKey) return -1;
      if (a.RowKey > b.RowKey) return 1;
      return a.programCode.localeCompare(b.programCode);
    });
    pools.S10Pools = temps10;
    temps13.sort((a, b) => {
      if (a.RowKey < b.RowKey) return -1;
      if (a.RowKey > b.RowKey) return 1;
      return a.PartitionKey.localeCompare(b.PartitionKey);
    });
    pools.S13Pools = temps13;
    temps4.sort((a, b) => {
      if (a.RowKey < b.RowKey) return -1;
      if (a.RowKey > b.RowKey) return 1;
      return a.programCode.localeCompare(b.programCode);
    });
    pools.S4Pools = temps4;
    temps13X.sort((a, b) => {
      if (a.RowKey < b.RowKey) return -1;
      if (a.RowKey > b.RowKey) return 1;
      return a.PartitionKey.localeCompare(b.PartitionKey);
    });
    pools.S13XPools = temps13X;
    // tempsM.sort((a, b) => {
    //       if (a.RowKey < b.RowKey) return -1;
    //       if (a.RowKey > b.RowKey) return 1;
    //       return a.PartitionKey.localeCompare(b.PartitionKey);
    //     });
    // pools.SMPools = tempsM;
    // temps8.sort((a, b) => {
    //       if (a.RowKey < b.RowKey) return -1;
    //       if (a.RowKey > b.RowKey) return 1;
    //       return a.PartitionKey.localeCompare(b.PartitionKey);
    //     });
    // pools.S8Pools = temps8;
    temps11.sort((a, b) => {
      if (a.RowKey < b.RowKey) return -1;
      if (a.RowKey > b.RowKey) return 1;
      return a.PartitionKey.localeCompare(b.PartitionKey);
    });
    pools.S11Pools = temps11;
    temps1.sort((a, b) => {
      if (a.RowKey < b.RowKey) return -1;
      if (a.RowKey > b.RowKey) return 1;
      return a.PartitionKey.localeCompare(b.PartitionKey);
    });
    pools.S1Pools = temps1;
    tempsS.sort((a, b) => {
      if (a.RowKey < b.RowKey) return -1;
      if (a.RowKey > b.RowKey) return 1;
      return a.PartitionKey.localeCompare(b.PartitionKey);
    });
    pools.SSPools = tempsS;
    tempsC.sort((a, b) => {
      if (a.RowKey < b.RowKey) return -1;
      if (a.RowKey > b.RowKey) return 1;
      return a.PartitionKey.localeCompare(b.PartitionKey);
    });
    pools.SCPools = tempsC;
    // const temp_volumes = [temps6.length, temps10.length, temps13.length, temps4.length, temps13X.length, tempsM.length, temps8.length, temps1.length];
    const temp_volumes = [
      temps6.length,
      temps10.length,
      temps13.length,
      temps4.length,
      temps13X.length,
      temps11.length,
      temps1.length,
      tempsS.length,
      tempsC.length,
    ];
    pools.PoolVolumes = temp_volumes;
    return pools;
  };

  // Fetch data every 2 min
  const { data = noPools } = useApi("/api/GetSummaryPools", { select: groupSummaryPools, refreshInterval: 120000 });
  const { PoolVolumes, S6Pools, S10Pools, S13Pools, S4Pools, S13XPools, S11Pools, S1Pools, SSPools, SCPools } = data;

  // Foundation's section script (index.html) applies the tabs' phone layout only on window
  // resize, and its load-time pass runs before these tabs exist. Without this, phones show an
  // empty block above the first tab until something else resizes the window. Foundation reads
  // the page width at that moment, so nothing may be wider than the screen (see Banners.js).
  const poolsLoaded = PoolVolumes.length > 0;
  useEffect(() => {
    if (poolsLoaded) window.dispatchEvent(new Event("resize"));
  }, [poolsLoaded]);

  return (
    <div className="large-8 columns pools" style={{ paddingLeft: "0.3em" }}>
      <div className="sectionheader">CURRENT POOLS</div>
      <div id="newtabs" className="section-container auto" data-section style={{ minHeight: "56px" }}>
        {!poolsLoaded ? (
          <>
            <PoolTabsLoader />
            <PoolItemLoader />
            <br />
            <PoolItemLoader />
          </>
        ) : (
          <PoolPanel pools={S6Pools} panel_selected={PanelSelected} panel_number={1} volume={PoolVolumes[0]} />
        )}
        <PoolPanel pools={S10Pools} panel_selected={PanelSelected} panel_number={2} volume={PoolVolumes[1]} />
        <PoolPanel pools={S13Pools} panel_selected={PanelSelected} panel_number={3} volume={PoolVolumes[2]} />
        <PoolPanel pools={S4Pools} panel_selected={PanelSelected} panel_number={4} volume={PoolVolumes[3]} />
        <PoolPanel pools={S13XPools} panel_selected={PanelSelected} panel_number={5} volume={PoolVolumes[4]} />
        {/*
        <PoolPanel pools={SMPools} panel_selected={PanelSelected} panel_number={6} volume={PoolVolumes[5]} />
        <PoolPanel pools={S8Pools} panel_selected={PanelSelected} panel_number={7} volume={PoolVolumes[6]} />
        <PoolPanel pools={S1Pools} panel_selected={PanelSelected} panel_number={8} volume={PoolVolumes[7]} />
        <PoolPanel pools={S8Pools} panel_selected={PanelSelected} panel_number={6} volume={PoolVolumes[5]} />
        */}
        <PoolPanel pools={S11Pools} panel_selected={PanelSelected} panel_number={6} volume={PoolVolumes[5]} />
        <PoolPanel pools={S1Pools} panel_selected={PanelSelected} panel_number={7} volume={PoolVolumes[6]} />
        <PoolPanel pools={SSPools} panel_selected={PanelSelected} panel_number={8} volume={PoolVolumes[7]} />
        <PoolPanel pools={SCPools} panel_selected={PanelSelected} panel_number={9} volume={PoolVolumes[8]} />
      </div>
    </div>
  );
};

export default PoolsWidget;
